'use strict';

var chunkM632V57T_js = require('./chunk-M632V57T.js');

function i(o){return `font_size_${o}`in chunkM632V57T_js.a}var r=o=>{if(i(o)){let e=`font_size_${o}`,n=`line_height_${o}`;return {fontSize:chunkM632V57T_js.a[e],lineHeight:chunkM632V57T_js.a[n]}}throw new Error(`Invalid font size: ${o}`)},s=o=>chunkM632V57T_js.a[`font_weight_${o}`];

exports.a = r;
exports.b = s;
